import { atom } from "jotai";

export const selectedThemeIdAtom = atom<string>("");
export const selectedIndicatorIdAtom = atom<string | undefined>(undefined);
export const selectedSubthemesAtom = atom<string[]>([]);
